import {defaultMemoize} from 'reselect';
import {getProcessOrphanSteps} from 'sweet-graphs';

import {denormalizeDocument} from 'app/procedures/selectors';
import {procedureStructureIsEqual} from 'app/procedures/utils';

import type {RootState} from 'app/store/root-reducer';
import type {ProcessContentType, ProcessSerializedType} from 'sweet-types';

export const getMemoizedProcessOrphanSteps = defaultMemoize(
  (content: ProcessContentType, stepsBlockedAt: string | null | boolean) =>
    getProcessOrphanSteps(content, stepsBlockedAt), // this equality check function is called with all inputs in turn.
  (prev, current) =>
    Array.isArray(prev) && Array.isArray(current)
      ? procedureStructureIsEqual(prev, current)
      : prev === current
);
export const denormalizeProcessFactory =
  (state: RootState) => (process: ProcessSerializedType) =>
    denormalizeDocument(state.teamsArea.get('basicTeams'), process);
